<template>
  <div class="box1">
    <img src="../../../assets/coursePage/java/box1/banner.png"/>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
};
</script>

<style lang="less" scoped>
.box1 {
 img{width: 100%;display: block;}
}
</style>
